var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CompanyGridViewModel = /** @class */ (function () {
    function CompanyGridViewModel() {
    }
    return CompanyGridViewModel;
}());
export { CompanyGridViewModel };
var CompanyViewModel = /** @class */ (function () {
    function CompanyViewModel() {
    }
    return CompanyViewModel;
}());
export { CompanyViewModel };
var DepartmentGridViewModel = /** @class */ (function () {
    function DepartmentGridViewModel() {
    }
    return DepartmentGridViewModel;
}());
export { DepartmentGridViewModel };
var DepartmentViewModel = /** @class */ (function () {
    function DepartmentViewModel() {
    }
    return DepartmentViewModel;
}());
export { DepartmentViewModel };
var SectionViewModel = /** @class */ (function () {
    function SectionViewModel() {
    }
    return SectionViewModel;
}());
export { SectionViewModel };
var AppraisalDetailRowViewModel = /** @class */ (function (_super) {
    __extends(AppraisalDetailRowViewModel, _super);
    function AppraisalDetailRowViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AppraisalDetailRowViewModel;
}(SectionViewModel));
export { AppraisalDetailRowViewModel };
var DeleteAppraisalsFilterViewModel = /** @class */ (function () {
    function DeleteAppraisalsFilterViewModel() {
    }
    return DeleteAppraisalsFilterViewModel;
}());
export { DeleteAppraisalsFilterViewModel };
var EmployeeAppraisalCalculationViewModel = /** @class */ (function () {
    function EmployeeAppraisalCalculationViewModel() {
    }
    return EmployeeAppraisalCalculationViewModel;
}());
export { EmployeeAppraisalCalculationViewModel };
var EmployeeAppraisalDetailViewModel = /** @class */ (function (_super) {
    __extends(EmployeeAppraisalDetailViewModel, _super);
    function EmployeeAppraisalDetailViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EmployeeAppraisalDetailViewModel;
}(EmployeeAppraisalCalculationViewModel));
export { EmployeeAppraisalDetailViewModel };
var EmployeeAppraisalFilterViewModel = /** @class */ (function () {
    function EmployeeAppraisalFilterViewModel() {
    }
    return EmployeeAppraisalFilterViewModel;
}());
export { EmployeeAppraisalFilterViewModel };
var EmployeeAppraisalGridViewModel = /** @class */ (function () {
    function EmployeeAppraisalGridViewModel() {
    }
    return EmployeeAppraisalGridViewModel;
}());
export { EmployeeAppraisalGridViewModel };
var EmployeeAppraisalRatingViewModel = /** @class */ (function () {
    function EmployeeAppraisalRatingViewModel() {
    }
    return EmployeeAppraisalRatingViewModel;
}());
export { EmployeeAppraisalRatingViewModel };
var EmployeeAppraisalViewModel = /** @class */ (function () {
    function EmployeeAppraisalViewModel() {
    }
    return EmployeeAppraisalViewModel;
}());
export { EmployeeAppraisalViewModel };
var EmployeeInfoViewModel = /** @class */ (function () {
    function EmployeeInfoViewModel() {
    }
    return EmployeeInfoViewModel;
}());
export { EmployeeInfoViewModel };
var ReviewApprovalViewModel = /** @class */ (function () {
    function ReviewApprovalViewModel() {
    }
    return ReviewApprovalViewModel;
}());
export { ReviewApprovalViewModel };
var VerificationReviewViewModel = /** @class */ (function () {
    function VerificationReviewViewModel() {
    }
    return VerificationReviewViewModel;
}());
export { VerificationReviewViewModel };
var EmployeeGridViewModel = /** @class */ (function () {
    function EmployeeGridViewModel() {
    }
    return EmployeeGridViewModel;
}());
export { EmployeeGridViewModel };
var EmployeeViewModel = /** @class */ (function () {
    function EmployeeViewModel() {
    }
    return EmployeeViewModel;
}());
export { EmployeeViewModel };
var FileContentViewModel = /** @class */ (function () {
    function FileContentViewModel() {
    }
    return FileContentViewModel;
}());
export { FileContentViewModel };
var ProfileViewModel = /** @class */ (function () {
    function ProfileViewModel() {
    }
    return ProfileViewModel;
}());
export { ProfileViewModel };
var FormGridViewModel = /** @class */ (function () {
    function FormGridViewModel() {
    }
    return FormGridViewModel;
}());
export { FormGridViewModel };
var FormViewModel = /** @class */ (function () {
    function FormViewModel() {
    }
    return FormViewModel;
}());
export { FormViewModel };
var JobLevelGridViewModel = /** @class */ (function () {
    function JobLevelGridViewModel() {
    }
    return JobLevelGridViewModel;
}());
export { JobLevelGridViewModel };
var JobLevelViewModel = /** @class */ (function () {
    function JobLevelViewModel() {
    }
    return JobLevelViewModel;
}());
export { JobLevelViewModel };
var LookupViewModel = /** @class */ (function () {
    function LookupViewModel() {
    }
    return LookupViewModel;
}());
export { LookupViewModel };
var PositionFactorCodesCheckViewModel = /** @class */ (function () {
    function PositionFactorCodesCheckViewModel() {
    }
    return PositionFactorCodesCheckViewModel;
}());
export { PositionFactorCodesCheckViewModel };
var PositionGridViewModel = /** @class */ (function () {
    function PositionGridViewModel() {
    }
    return PositionGridViewModel;
}());
export { PositionGridViewModel };
var PositionViewModel = /** @class */ (function () {
    function PositionViewModel() {
    }
    return PositionViewModel;
}());
export { PositionViewModel };
var RatingGridViewModel = /** @class */ (function () {
    function RatingGridViewModel() {
    }
    return RatingGridViewModel;
}());
export { RatingGridViewModel };
var RatingViewModel = /** @class */ (function () {
    function RatingViewModel() {
    }
    return RatingViewModel;
}());
export { RatingViewModel };
var LookupRequestViewModel = /** @class */ (function () {
    function LookupRequestViewModel() {
    }
    return LookupRequestViewModel;
}());
export { LookupRequestViewModel };
var ResponseBase = /** @class */ (function () {
    function ResponseBase() {
    }
    return ResponseBase;
}());
export { ResponseBase };
var Response = /** @class */ (function (_super) {
    __extends(Response, _super);
    function Response() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Response;
}(ResponseBase));
export { Response };
var SectionGridViewModel = /** @class */ (function () {
    function SectionGridViewModel() {
    }
    return SectionGridViewModel;
}());
export { SectionGridViewModel };
var LoginResult = /** @class */ (function () {
    function LoginResult() {
    }
    return LoginResult;
}());
export { LoginResult };
var TokenResult = /** @class */ (function () {
    function TokenResult() {
    }
    return TokenResult;
}());
export { TokenResult };
var UserCompanyRangesViewModel = /** @class */ (function () {
    function UserCompanyRangesViewModel() {
    }
    return UserCompanyRangesViewModel;
}());
export { UserCompanyRangesViewModel };
var UserCompanyViewModel = /** @class */ (function () {
    function UserCompanyViewModel() {
    }
    return UserCompanyViewModel;
}());
export { UserCompanyViewModel };
var UserGridViewModel = /** @class */ (function () {
    function UserGridViewModel() {
    }
    return UserGridViewModel;
}());
export { UserGridViewModel };
var UserViewModel = /** @class */ (function () {
    function UserViewModel() {
    }
    return UserViewModel;
}());
export { UserViewModel };
var CodeValidationViewModel = /** @class */ (function () {
    function CodeValidationViewModel() {
    }
    return CodeValidationViewModel;
}());
export { CodeValidationViewModel };
var SecureLinkViewModel = /** @class */ (function () {
    function SecureLinkViewModel() {
    }
    return SecureLinkViewModel;
}());
export { SecureLinkViewModel };
var CloneEntitiesViewModel = /** @class */ (function () {
    function CloneEntitiesViewModel() {
    }
    return CloneEntitiesViewModel;
}());
export { CloneEntitiesViewModel };
